import { render } from "./appUser.vue?vue&type=template&id=1c65f704&scoped=true"
import script from "./appUser.vue?vue&type=script&lang=js"
export * from "./appUser.vue?vue&type=script&lang=js"

import "./appUser.vue?vue&type=style&index=0&id=1c65f704&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c65f704"]])

export default __exports__